<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link  v-if="checkPermission('AddPaiement')"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/paiement">
          Nouveau Paiement
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <button type="button" @click="getPoint()" v-if="valideEtape3"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          Exporter
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
              <ErrorMessage name="mot" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Usager
              </label>
              <Field v-model="usager" name="contrat" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Sélectionner un usager"
                  contratholder="Rechercher une usager" :filter-results="false" @select="usagerSelect" :min-chars="3"
                  :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                    return await getUsager(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="contrat" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteur
              </label>
              <Field name="secteur" v-slot="{ field }" v-model="secteur"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="secteursOptions" :searchable="true"
                  noResultText="Aucun enregistrement trouvé" placeholder="Rechercher par secteur" />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Etats
              </label>
              <Field name="etat" v-slot="{ field }" v-model="etat"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="etatsOptions" :searchable="true"
                  noResultText="Aucun enregistrement trouvé" placeholder="Rechercher par secteur" />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>

        </div>
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Locataire
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Exploitant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Place
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mois Total
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mois Payé
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Total
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ret, index) in retours" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ ret.locataire }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ ret.exploitant }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ ret.ncode_emp }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ separateur(parseFloat(ret.loyer)) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ ret.moisDuTotal }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ ret.moisPaye }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(parseFloat(ret.montantPaye)) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a @click="getApercu(ret)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Apercu du statut
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  dateActuelle,
  success,
  getUrlApiForFiles,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import { checkPermission } from "@/utils/utils";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListePaiementUsager",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const lemontant = ref("0");
    const donn = ref();
    const usager = ref();
    const secteur = ref();
    const etat = ref();
    const etatsOptions = ref<Array<any>>([
      { value: "1", label: "En attente" },
      { value: "2", label: "Payé" },
      { value: "3", label: "Annulé" },
      { value: "4", label: "Régularisé" },
      { value: "5", label: "Régularisé" },
      { value: "6", label: "Régularisé" },
      { value: "7", label: "Régularisé" }
    ]);
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };
    const getUser = async () => {
      try {
        const response = await axios.get("/tout/users");
        const donnee = response.data.data;
        agentOptions.value = donnee.map((agent) => ({
          value: agent.id,
          label: agent.nomComplet,
        }));
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    const valideEtape3 = ref(true);
    const recharger = async () => {
      await actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const retours: any = ref<Array<any>>([]);


    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "PointUsager") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }

    const getApercu = async (value: any) => {
      try {
        if (value) {
          const response = await axios.post("/getPointUsager", value);
          if ((response).status == 200) {
            //openNewWindow(response.data.data);
          }
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }

    }

    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      const element = {
        motCle: motCle.value,
        recherche: motCle.value,
        usager: usager.value,
        secteur: secteur.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
      };
      try {
        const response = await axios.post("/getPointParUsager", element);
        const donnees = response.data.data.data;
        retours.value = donnees;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
        lemontant.value = separateur(response.data.data.montant) + " (FCFA)";
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    const getPoint = async () => {
      try {

        valideEtape3.value = false;
        donn.value = {
          dateDebut:
            (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin:
            (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          acteur: agent.value,
        };
        const response = await axios.post("/getPoint", donn.value);
        openNewWindow({ reference: response.data.data }, "Point");
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    watch(motCle, async (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      await actionRecherche(page.value, limit.value);
    });
    watch(usager, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      usager.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    watch(secteur, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      secteur.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    const supprime = async (id) => {
      Swal.fire({
        text: `Vous êtes sur le point de supprimer le retour n° ${id}. Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
        .then((result) => {
          if (result.isConfirmed) {
            ApiService.delete(`delete/retour/${id}`)
              .then(async ({ data }) => {
                if (data.code == 200) {
                  success(data.message);
                  //retours.value = supprimerElement(id, retours.value);
                  await actionRecherche(1, 10);
                }
              })
              .catch(async ({ response }) => {
                error(response.message);
              });
          }
        })
        .catch(async ({ response }) => {
          error(response.message);
        });
    };
    const usagerSelect = (value) => {
      usager.value = value;
    };
    const secteurOptions = ref<Array<any>>([]);
    const getSecteurs = async () => {
      try {
        const response = await axios.get("all/secteur");
        secteursOptions.value = response.data.data.map((secteur) => ({
          value: secteur.code_secteur,
          label: secteur.code_secteur + " - " + secteur.libelle_secteur,
        }));
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    const getUsager = async (query: string) => {
      if (query.length < 3) return [];
      try {
        const response = await axios.get("getUsagersParCle/" + query);
        return response.data.data.map((usager) => ({
          value: usager.matricule,
          label: usager.full_name + " (" + usager.matricule + ")" + " (" + usager.ifu + ")" + " (" + usager.npi + ")",
        }));
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    onMounted(async () => {
      await getSecteurs();
      await actionRecherche(1, 10);
    });
    return {
      usager,
      getApercu,
      usagerSelect,
      getUsager,
      secteurOptions,
      dateDebut,
      dateFin,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      openNewWindow,
      retours,
      secteursOptions,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      checkPermission,
      error,
      lemontant,
      getPoint,
      valideEtape3,
      dateActuelle,
      supprime,
      secteur,
      etatsOptions,
      etat
    };
  },
});
</script>